module.exports = __webpack_public_path__ + "db87b5e00a4edb625174c7fbe9dc26e6.png";